import { render } from "./AwardManageView.vue?vue&type=template&id=7781569b&scoped=true"
import script from "./AwardManageView.vue?vue&type=script&lang=js"
export * from "./AwardManageView.vue?vue&type=script&lang=js"

import "./AwardManageView.vue?vue&type=style&index=0&id=7781569b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7781569b"]])

export default __exports__